import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import MainLayout from './components/MainLayout';
import FileUpload from './Pages/fileUpload'; // Adjusted import path
import InitialQuestion from './Pages/InitialQuestion';
import DescribeIssueParent from './Pages/DescribeIssueParent';
import ProfilePage from './Pages/ProfilePage';
import LoginPage from './Pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute component
import UserHomePage from './Pages/UserHomePage';
import AuthTokenProvider from './components/AuthTokenProvider'; // Import the AuthTokenProvider
import WelcomePage from './Pages/WelcomePage';
import SubscriptionNeededPage from './Pages/SubscriptionNeededPage';
import SubscriptionSuccessfulPage from './Pages/SubscriptionSuccessfulPage';
import InspectionEvaluation from './Pages/InspectionEvaluation';
import ImprovementEvaluation from './Pages/ImprovementEvaluation';
import InspectionEvaluationHome from './Pages/InspectionEvaluationHome';
import ImprovementEvaluationHome from './Pages/ImprovementEvaluationHome';
import PropertyViewPage from './Pages/PropertyViewPage';
import PropertyListPage from './Pages/PropertyListPage';
import QuoteAnalysis from './Pages/QuoteAnalysis';
import { LoadScript } from '@react-google-maps/api';


const theme = createTheme({
  palette: {
    primary: {
      main: '#131E3A',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#fafafa',
    },
    text: {
      primary: '#212121',
    },
  },
});

const App: React.FC = () => {
  return (
    <Auth0Provider
    domain="dev-sezetbcdrq6kmusc.us.auth0.com"
    clientId="nwsEnWHVxe6LGoj8FeDvjrla1NGJqSGN"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://fxer.ai/api"
    }}
  >
      <AuthTokenProvider>
      <LoadScript
      googleMapsApiKey="AIzaSyAWd4OzOoQPEMoPf2LaxvhNDh79FA4cgic" // Replace with your API key
      libraries={['places']} // Ensure the Places library is loaded
    >
        <ThemeProvider theme={theme}>
          <Router>
            <Routes>
              <Route path="/*" element={
                <>
                  <MainLayout />
                  <div className="pt-16 pl-0 md:pl-64 min-h-screen">
                    <Routes>
                      <Route path="/" element={<ProtectedRoute component={PropertyListPage} />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/welcome" element={<ProtectedRoute component={WelcomePage} />} />
                      <Route path="/upload" element={<ProtectedRoute component={FileUpload} />} />
                      <Route path="/repair" element={<ProtectedRoute component={DescribeIssueParent} />} />
                      <Route path="/repair/:id" element={<ProtectedRoute component={DescribeIssueParent} />} />
                      <Route path="/project" element={<ProtectedRoute component={FileUpload} />} />
                      <Route path="/profile" element={<ProtectedRoute component={ProfilePage} />} />
                      <Route path="/subscription" element={<ProtectedRoute component={SubscriptionNeededPage} />} />
                      <Route path="/success" element={<ProtectedRoute component={SubscriptionSuccessfulPage} />} />
                      <Route path="/inspection" element={<ProtectedRoute component={InspectionEvaluationHome} />} />
                      <Route path="/inspection/:inspectionId" element={<ProtectedRoute component={InspectionEvaluation} />} />
                      <Route path="/improvement" element={<ProtectedRoute component={ImprovementEvaluation} />} />
                      <Route path="/property/:propertyId/*" element={<ProtectedRoute component={PropertyViewPage} />} />
                      <Route path="/property/" element={<ProtectedRoute component={PropertyListPage} />} />
                      <Route path="/quote/" element={<ProtectedRoute component={QuoteAnalysis} />} />
                    </Routes>
                  </div>
                </>
              } />
            </Routes>
          </Router>
        </ThemeProvider>
        </LoadScript>
      </AuthTokenProvider>
    </Auth0Provider>
  );
};

export default App;
